module.exports = __webpack_public_path__ + "static/kobold_tribe-0190230bb74e002849153e15c369470a.jpg";